import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';

interface IProps {
	settingsId: string;
	splitPayments3S: boolean;
	onToggleSplitPayments3S: () => void;
}

export const SplitPayments3SCheckbox: React.FC<IProps> = React.memo(
	({ settingsId, splitPayments3S, onToggleSplitPayments3S }) => (
		<Form.Item data-test="SplitPayments3SCheckbox" name={`splitPayments3S-${settingsId}`}>
			<Checkbox checked={splitPayments3S} onChange={onToggleSplitPayments3S}>
				<Text translationNameSpace="form" translationKey="splitPayments3SLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	),
);
